/**
 * 도움말 → AI 탭 연결 통로.
 *
 * 헤더의 「도움말」 메뉴는 디자이너 밖(대시보드·실행 탭)에서도 눌린다. AI 패널은 디자이너의 오른쪽 패널 안에서,
 * 그것도 AI 탭을 처음 열 때 비로소 마운트된다. 그래서 "AI 에게 물어보기" 는 세 단계를 거친다:
 *   ① App 이 화면을 디자이너로 → ② AiDrawer 가 창을 연다 → ③ AssistantPanel 이 입력란에 채운다(또는 보낸다).
 * ①②는 window 이벤트로 알리고, ③은 패널이 아직 없을 수 있어 **대기 요청**으로 남겨 두었다가 마운트되면 가져간다.
 *
 * 기본은 **채우기만** 한다(보내지 않음) — 사용자가 고쳐서 보낼 수 있게 (datamodeler 의 CHAT_PREFILL 과 같다).
 */
export interface AssistantAsk { text: string; send?: boolean }

export const HELP_ASK_EVENT = 'openflow:assistant-ask';

let pending: AssistantAsk | null = null;

/** 도움말에서 어시스턴트에게 — 화면·탭을 열고 글을 넘긴다 */
export function askAssistant(text: string, opts: { send?: boolean } = {}) {
  pending = { text, send: !!opts.send };
  window.dispatchEvent(new CustomEvent<AssistantAsk>(HELP_ASK_EVENT, { detail: pending }));
}

/** 소비하지 않고 들여다본다 — AiDrawer 가 마운트 시 창을 열지 판단할 때 (패널이 뒤에 가져간다) */
export function peekPendingAsk(): AssistantAsk | null { return pending; }

/** 패널이 마운트될 때 가져간다 — 한 번만 */
export function takePendingAsk(): AssistantAsk | null {
  const p = pending;
  pending = null;
  return p;
}

export function clearPendingAsk() { pending = null; }

// ── 어시스턴트가 고른 노드 선택 ──
// 노드를 클릭하면 오른쪽 패널이 「노드 속성」 탭으로 넘어간다(사용자가 클릭했으니 당연하다).
// 그런데 도움말·도구(add_node·focus_node)가 노드를 선택할 때도 같은 일이 벌어져 AI 탭이 닫히고 도움말 버튼이 사라졌다(실측).
// 도구가 선택하기 직전에 표시해 두면 그 선택은 사용자 클릭과 구분된다.
let assistantSelectAt = 0;
export function markAssistantSelection() { assistantSelectAt = Date.now(); }
export function isAssistantSelection() { return Date.now() - assistantSelectAt < 1500; }
